import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { CryptodraftContext } from '../../../../contexts/card/cryptodraft/context';
import { cryptodraftScreens } from '../constants';
import MainBodyLayout from '../partials/MainBodyLayout';
import { dynamicAssets } from '../../../../utilities/helpers';

const CryptodraftPromo = () => {
  const { t: translate } = useTranslation();
  const history = useHistory();

  const { openScreen, updateHintsVisibility } = useContext(CryptodraftContext);

  return (
    <MainBodyLayout
      withBack
      withInfoIcon
      onPrevClick={() => history.push('/dashboard/card/details')}
      title={translate('cryptodraft_promotional_title')}>
      <div className="d-flex flex-row justify-content-center align-items-center mt-5 pt-2">
        <img
          style={{ maxWidth: '223px' }}
          src={dynamicAssets('./assets/images/cryptodraft-promo.png')}
          alt="Promo"
        />
      </div>

      {/* mobile */}
      <p className="d-block d-md-none mt-5 pt-2 text-dark text-f4">
        {translate('cryptodraft_promotional_subtitle')}
      </p>

      {/* browser */}
      <p className="d-none d-md-block mt-5 pt-2 text-dark text-f5">
        {translate('cryptodraft_promotional_subtitle')}
      </p>

      <p className="mt-3 text-shadow text-f5">{translate('cryptodraft_promotional_note')}</p>

      <div className="d-flex flex-column flex-md-row justify-content-md-between align-items-md-center mt-4">
        <div className="d-flex flex-column">
          <div className="d-flex flex-row justify-content-start align-items-center">
            <i className="icon icon-done-status text-primary text-f5 me-2" aria-label="Back" />

            {/* mobile */}
            <p className="d-block d-md-none ps-1 text-dark text-f5">
              {translate('cryptodraft_promotional_feature_1')}
            </p>

            {/* browser */}
            <p className="d-none d-md-block ps-1 text-dark text-f6">
              {translate('cryptodraft_promotional_feature_1')}
            </p>
          </div>
          <div className="d-flex flex-row justify-content-start align-items-center mt-3">
            <i className="icon icon-done-status text-primary text-f5 me-2" aria-label="Back" />

            {/* mobile */}
            <p className="d-block d-md-none ps-1 text-dark text-nowrap text-f5">
              {translate('cryptodraft_promotional_feature_2')}
            </p>

            {/* browser */}
            <p className="d-none d-md-block ps-1 text-dark text-nowrap text-f6">
              {translate('cryptodraft_promotional_feature_2')}
            </p>
          </div>
        </div>
        <div className="d-flex flex-column pt-2 pt-md-0 ps-md-5">
          <div className="d-flex flex-row justify-content-start align-items-center pt-2">
            <i className="icon icon-done-status text-primary text-f5 me-2" aria-label="Back" />

            {/* mobile */}
            <p className="d-block d-md-none ps-1 text-dark text-f5">
              {translate('cryptodraft_promotional_feature_3')}
            </p>

            {/* browser */}
            <p className="d-none d-md-block ps-1 text-dark text-f6">
              {translate('cryptodraft_promotional_feature_3')}
            </p>
          </div>
          <div className="d-flex flex-row justify-content-start align-items-center mt-3">
            <i className="icon icon-done-status text-primary text-f5 me-2" aria-label="Back" />

            {/* mobile */}
            <p className="d-block d-md-none ps-1 text-dark text-f5">
              {translate('cryptodraft_promotional_feature_4')}
            </p>

            {/* browser */}
            <p className="d-none d-md-block ps-1 text-dark text-f6">
              {translate('cryptodraft_promotional_feature_4')}
            </p>
          </div>
        </div>
      </div>
      {!process.env.REACT_APP_CLIENT_NAME && (
        <a
          href="https://www.withcl.com/rewards"
          target="_blank"
          className="alert alert-info d-flex mt-4 cursor-pointer text-decoration-none"
          rel="noreferrer">
          <i className="icon icon-info-icon position-relative start-0" />
          <div className="content">
            {translate('cryptodraft_staking_note')}{' '}
            <span className="text-info">
              {translate('cryptodraft_staking_note_learn_more_label')}
            </span>
          </div>
        </a>
      )}
      <div className="btn-container">
        <button
          type="button"
          className="btn py-3 btn-primary w-100"
          onClick={() => {
            updateHintsVisibility({ first: true, second: false, third: false });
            openScreen(cryptodraftScreens.CALCULATOR);
          }}>
          {translate('cryptodraft_promotional_btn_label')}
        </button>
      </div>
    </MainBodyLayout>
  );
};

export default CryptodraftPromo;
